import { Component, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { FirestoreService } from '../firestore-service.service';
import { environment } from 'src/environments/environment';
import { SharedServiceService } from '../shared-service.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-left-header',
    templateUrl: environment.site === 'wroolo' ? './left-header.component.wroolo.html' : './left-header.component.productly.html',
    styleUrl: './left-header.component.scss',
    standalone: true,
    imports: [CommonModule, FormsModule]
})
export class LeftHeaderComponent {
  @Input() organizationKey: string = '';
  @Input() organizationName: string = '';
  @Input() projectKey: string = '';
  @Input() teamKey: string = '';
  @Input() teamName: string = '';
  @Input() isReadOnly: boolean = false;
  @Input() userId: string = '';
  @Input() segment: string = "";
  @Input() isMenuExpanded: boolean = true;
  @Input() organizations: {"key": string, "name": string, "projectCount": number, "memberCount": number}[] = []
  @Output() refreshContent = new EventEmitter<boolean>();
  @Output() sendExpandMenu = new EventEmitter<boolean>();
  @Output() swapProject = new EventEmitter<string>();
  @Output() swapOrganization = new EventEmitter<string>();
  @Output() clickedOutside = new EventEmitter<any>();

  postCount = 0;
  workpackageCount = 0;
  bookCount = 0;
  commentCount = 0;
  newsCount = 0;
  canvasCount = 0;
  site = ""
  systemName = ""
  teamMemberCount = 0
  isTeamExpanded = false
  isOrganizationExpanded = false
  teams: any[] = []
  projects: any[] = []
  unsubOrg: any
  unsubPrj: any

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkMobile();
  }

  constructor(private router: Router, private firestore: FirestoreService, private service: SharedServiceService) {
    this.unsubOrg = this.service.organizationKey.subscribe(org => { // listen to organizationKey passed from query in component (I can't listen to query in header component for it is not defined in routing_module)
      if (org != undefined && org != "undefined" && org != "" && org != this.organizationKey) {
        this.organizationKey = org
      }
    })
    this.unsubPrj = this.service.projectKey.subscribe(prj => { // subscribe to changes to projectkey coming from other components
      if (prj != undefined && prj != "undefined" && prj != "" && prj != this.projectKey) {
        this.projectKey = prj
        this.getProjects()
      } 
    //   this.firestoreService.getProjectReadOnlyStatus(this.organizationKey, this.projectKey, this.userId).then(readonly => {
   //     this.isReadOnly = readonly
    //  })
    })

  }

  onClickedOutside(event: any) {
    this.clickedOutside.emit(event)
  }

  async ngAfterViewInit() {
    this.checkMobile();
    //await this.getTeams()
    //await this.getProjectsByTeam(this.teamKey)
    if (this.organizations.length == 0) {
      await this.loadOrganizations()
    }
    await this.getProjects()
  }

  ngOnChanges() {
    if (this.organizationKey != "" && this.projectKey != "" && this.organizationKey && this.projectKey) {
      this.getNumberOfItems()
    }
    this.site = environment.site
    if (this.site == "wroolo") {
      this.systemName = "Wroolo"
    } else {
      this.systemName = "Productly"
    }
  }

  ngOnDestroy() {
    if (this.unsubOrg) {
      this.unsubOrg.unsubscribe()
    }
    if (this.unsubPrj) {
      this.unsubPrj.unsubscribe()
    }
  }

  async loadOrganizations() {
    await this.firestore.getOrganizations(this.userId).then(result => {
      this.organizations = result.map((org: any) => {
        return {
          "key": org.key,
          "name": org.name,
          "projectCount": org.projectCount,
          "memberCount": org.userCount
        }
      })
      this.organizationName = this.organizations.find(o => o.key == this.organizationKey)?.name || ""
    })
  }

  checkMobile() {
    const isMobile = window.innerWidth <= 768;
    if (isMobile) {
      this.isMenuExpanded = false; // Collapse menu on mobile
    } else {
      this.isMenuExpanded = true;
    }
    this.sendExpandMenu.emit(this.isMenuExpanded);
  }

  contentRefreshed() {
    this.refreshContent.emit(true);
  }

  navigateTo(segment: string, organizationKey: string = "", projectKey: string = "") {
    if (organizationKey == "") {
      this.router.navigate([segment])
    } else if (projectKey == "") {
      this.router.navigate([segment+"/"+organizationKey])
    } else if (segment == "startscreen") {
      this.router.navigate([segment+"/"+false+"/"+organizationKey+"/"+projectKey])
    } else {
      this.router.navigate([segment+"/"+organizationKey+"/"+projectKey])
    }
  }

  expandMenu() {
    this.isMenuExpanded = !this.isMenuExpanded;
    this.sendExpandMenu.emit(this.isMenuExpanded);
  }

  async getNumberOfItems() {
    await this.firestore.getItemCounts(this.organizationKey, this.projectKey).then(result => {
      this.workpackageCount = result.workpackageCount
      this.postCount = result.postCount
      this.bookCount = result.bookCount
      this.commentCount = result.commentCount
      this.newsCount = result.newsCount
      this.canvasCount = result.canvasCount
      })
  }

 /* async getTeams() {
    const teams = await this.firestore.getTeamsByUser(this.organizationKey, this.userId).then(result => {
      this.teams = [...result]
      this.teamMemberCount = this.teams.find(t => t.key == this.teamKey)?.userKeys.length || 0
      this.teamName = this.teams.find(t => t.key == this.teamKey)?.name || ""
      return result
    })
    if (this.teamKey == "") {
      this.teamKey = this.teams.find(t => t.projectKeys.includes(this.projectKey))?.key || ""
    }
    return teams
  }*/

  async getProjects() {
    await this.firestore.getUserOrganizationProjects(this.organizationKey, this.userId).then(result => {
      this.projects = [...result]
    })
    this.projects = this.projects.sort((a, b) => a.name.localeCompare(b.name))
  }

  /*async getProjectsByTeam(teamKey: string) {
    const team = this.teams.find(t => t.key == teamKey)
    this.projects.length = 0
   // await team?.projectKeys.forEach(async (projectKey: string) => {
    if (team && team.projectKeys.length > 0) {
      for (let projectKey of team.projectKeys) {
        await this.firestore.getProject(this.organizationKey, projectKey).then(result => {
          const project = {key: projectKey, name: result.name, teamKey: teamKey, projectKey: projectKey, commentCount: result.commentCount, postCount: result.postCount, workpackageCount: result.workpackageCount, userCount: result.userCount}
          this.projects.push(project)
        })
      }
    }
    this.projects = this.projects.sort((a, b) => a.name.localeCompare(b.name))
  }*/

  uploadJsons() {

  }

  expandTeam() {
    this.isTeamExpanded = !this.isTeamExpanded
  }

  expandOrganizations() {
    this.isOrganizationExpanded = !this.isOrganizationExpanded
  }

  /*swapTeam(teamKey: string) {
    this.teamKey = teamKey
    this.getTeams()
   // this.getProjectsByTeam(teamKey)
  }*/

  onSwapProject(projectKey: string) {
    if (this.segment != "admin") {
      this.projectKey = projectKey
      this.swapProject.emit(projectKey)
    } else {
      this.router.navigate(["canvaslist/"+this.organizationKey+"/"+projectKey])
    }
  }

  onSwapOrganization(organizationKey: string) { 
    this.organizationKey = organizationKey
    this.organizationName = this.organizations.find(o => o.key == organizationKey)?.name || ""
    this.isOrganizationExpanded = false
    this.swapOrganization.emit(organizationKey)
    this.getProjects()
  }
}
